// /**
//  * CreditCard Component
//  * 
//  * Individual credit card with 3D animations:
//  * - 3D flip on hover
//  * - Tilt effect based on mouse position
//  * - Floating animation
//  * - Shimmer effect on chip
//  */

// import { useRef, useCallback } from 'react'
// import { useModal } from '../context/ModalContext'
// import '../styles/CreditCard.css'

// function CreditCard({ plan, index }) {
//   const cardRef = useRef(null)
//   const { openModal } = useModal()

//   /**
//    * Handle mouse movement for 3D tilt effect
//    */
//   const handleMouseMove = useCallback((e) => {
//     // Check for reduced motion preference
//     if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//       return
//     }

//     const card = cardRef.current
//     if (!card) return

//     const rect = card.getBoundingClientRect()
//     const centerX = rect.left + rect.width / 2
//     const centerY = rect.top + rect.height / 2
//     const mouseX = e.clientX - centerX
//     const mouseY = e.clientY - centerY

//     // Calculate rotation (max 15 degrees)
//     const maxRotation = 15
//     const rotateX = (mouseY / (rect.height / 2)) * -maxRotation
//     const rotateY = (mouseX / (rect.width / 2)) * maxRotation

//     card.style.setProperty('--tilt-x', `${rotateX}deg`)
//     card.style.setProperty('--tilt-y', `${rotateY}deg`)
//   }, [])

//   /**
//    * Reset card position when mouse leaves
//    */
//   const handleMouseLeave = useCallback(() => {
//     const card = cardRef.current
//     if (!card) return

//     card.style.setProperty('--tilt-x', '0deg')
//     card.style.setProperty('--tilt-y', '0deg')
//   }, [])

//   /**
//    * Handle card selection
//    */
//   const handleSelect = useCallback(() => {
//     openModal(plan.name, plan.fee)
//   }, [openModal, plan.name, plan.fee])

//   /**
//    * Handle keyboard navigation
//    */
//   const handleKeyDown = useCallback((e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault()
//       handleSelect()
//     }
//   }, [handleSelect])

//   return (
//     <article 
//       className={`credit-card-wrapper ${plan.featured ? 'featured' : ''}`}
//       data-plan={plan.id}
//       style={{ '--card-index': index }}
//     >
//       {plan.featured && (
//         <div className="featured-badge">
//           <i className="fas fa-star" aria-hidden="true"></i>
//           BELIEBT
//         </div>
//       )}

//       <div
//         ref={cardRef}
//         className="credit-card"
//         tabIndex={0}
//         role="button"
//         aria-label={`${plan.name} auswählen: Kredit von ${plan.creditRange}, Gebühr ${plan.fee}`}
//         onClick={handleSelect}
//         onKeyDown={handleKeyDown}
//         onMouseMove={handleMouseMove}
//         onMouseLeave={handleMouseLeave}
//       >
//         {/* Card Front */}
//         <div className="card-front">
//           <div className={`card-background ${plan.cardBackground}`}></div>
//           <div className="card-content">
//             {/* Card Header */}
//             <div className="card-header">
//               <span className="card-brand">AIDFOUNDATION</span>
              
//                 <img 
//                   src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" 
//                   alt="VISA" 
//                   className="visa-logo"
//                 />
              
//             </div>

//             {/* Chip with Shimmer Effect */}
//             <div className={`card-chip ${plan.chipGold ? 'gold' : ''}`} aria-hidden="true">
//               <div className="chip-line"></div>
//               <div className="chip-line"></div>
//               <div className="chip-line"></div>
//               <div className="chip-line"></div>
//               <div className="chip-shimmer"></div>
//             </div>

//             {/* Card Number */}
//             <div className="card-number" aria-label="Kartennummer">
//               <span>••••</span>
//               <span>••••</span>
//               <span>••••</span>
//               <span>{plan.lastFourDigits}</span>
//             </div>

//             {/* Card Footer */}
//             <div className="card-footer">
//               <div className="card-holder">
//                 <span className="label">KARTENINHABER</span>
//                 <span className="value">IHR NAME</span>
//               </div>
//               <div className="card-expiry">
//                 <span className="label">GÜLTIG BIS</span>
//                 <span className="value">12/28</span>
//               </div>
//             </div>

//             {/* Plan Badge */}
//             <div className={`plan-badge ${plan.badgeClass}`}>{plan.badge}</div>
//           </div>
//         </div>

//         {/* Card Back */}
//         <div className="card-back">
//           <div className={`card-background ${plan.cardBackground}`}></div>
//           <div className={`magnetic-stripe ${plan.chipGold ? 'gold' : ''}`}></div>
//           <div className="signature-strip">
//             <div className="cvv-box">
//               <span className="cvv-label">CVV</span>
//               <span className="cvv-value">•••</span>
//             </div>
//           </div>
//           <div className="card-back-info">
//             <p>Diese Karte ist Eigentum der ausstellenden Bank.</p>
//             <p>Bei Fund bitte zurückgeben.</p>
//           </div>
//           <div className="card-back-logo">
//             <img 
//               src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" 
//               alt="VISA"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Plan Details */}
//       <div className="plan-details">
//         <h3 className="plan-name">{plan.name}</h3>
//         <div className="plan-info">
//           <div className="info-row">
//             <i className="fas fa-euro-sign" aria-hidden="true"></i>
//             <span>Kreditbetrag: <strong>{plan.creditRange}</strong></span>
//           </div>
//           <div className="info-row">
//             <i className="fas fa-calendar-alt" aria-hidden="true"></i>
//             <span>Laufzeit: <strong>{plan.duration}</strong></span>
//           </div>
//           <div className="info-row fee">
//             <i className="fas fa-tag" aria-hidden="true"></i>
//             <span>Kartengebühr: <strong className="price">{plan.fee}</strong></span>
//           </div>
//         </div>
//         <button 
//           className="select-btn"
//           onClick={handleSelect}
//           aria-label={`${plan.name} für ${plan.fee} auswählen`}
//         >
//           <span>Plan Auswählen</span>
//           <i className="fas fa-arrow-right" aria-hidden="true"></i>
//         </button>
//       </div>
//     </article>
//   )
// }

// export default CreditCard



import { useRef, useCallback } from 'react'
import { useModal } from '../context/ModalContext'
import '../styles/CreditCard.css'

function CreditCard({ plan, index }) {
  const cardRef = useRef(null)
  const { openModal } = useModal()

  /**
   * Handle mouse movement for 3D tilt effect
   */
  const handleMouseMove = useCallback((e) => {
    if (typeof window !== 'undefined') {
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches

      if (prefersReducedMotion) return
    }

    const card = cardRef.current
    if (!card) return

    const rect = card.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2

    const mouseX = e.clientX - centerX
    const mouseY = e.clientY - centerY

    const maxRotation = 15
    const rotateX = (mouseY / (rect.height / 2)) * -maxRotation
    const rotateY = (mouseX / (rect.width / 2)) * maxRotation

    card.style.setProperty('--tilt-x', `${rotateX}deg`)
    card.style.setProperty('--tilt-y', `${rotateY}deg`)
  }, [])

  /**
   * Reset tilt on mouse leave
   */
  const handleMouseLeave = useCallback(() => {
    const card = cardRef.current
    if (!card) return

    card.style.setProperty('--tilt-x', '0deg')
    card.style.setProperty('--tilt-y', '0deg')
  }, [])

  /**
   * Handle card selection
   */
  const handleSelect = useCallback(() => {
    openModal(plan.name, plan.fee)
  }, [openModal, plan.name, plan.fee])

  /**
   * Keyboard support
   */
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleSelect()
      }
    },
    [handleSelect]
  )

  return (
    <article
      className={`credit-card-wrapper ${plan.featured ? 'featured' : ''}`}
      data-plan={plan.id}
      style={{ '--card-index': `${index}` }}
    >
      {plan.featured && (
        <div className="featured-badge">
          <i className="fas fa-star" aria-hidden="true"></i>
          BELIEBT
        </div>
      )}

      <div
        ref={cardRef}
        className="credit-card"
        tabIndex={0}
        role="button"
        aria-label={`${plan.name} auswählen: Kredit ${plan.creditRange}, Gebühr ${plan.fee}`}
        onClick={handleSelect}
        onKeyDown={handleKeyDown}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        {/* FRONT */}
        <div className="card-front">
          <div className={`card-background ${plan.cardBackground}`} />

          <div className="card-content">
            {/* Header */}
            <div className="card-header">
              <span className="card-brand">AIDFOUNDATION</span>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
                alt="VISA"
                className="visa-logo"
              />
            </div>

            {/* Chip */}
            <div
              className={`card-chip ${plan.chipGold ? 'gold' : ''}`}
              aria-hidden="true"
            >
              <div className="chip-line" />
              <div className="chip-line" />
              <div className="chip-line" />
              <div className="chip-line" />
              <div className="chip-shimmer" />
            </div>

            {/* Card Number */}
            <div className="card-number">
              <span>••••</span>
              <span>••••</span>
              <span>••••</span>
              <span>{plan.lastFourDigits}</span>
            </div>

            {/* Footer */}
            <div className="card-footer">
              <div className="card-holder">
                <span className="label">KARTENINHABER</span>
                <span className="value">IHR NAME</span>
              </div>
              <div className="card-expiry">
                <span className="label">GÜLTIG BIS</span>
                <span className="value">12/28</span>
              </div>
            </div>

            <div className={`plan-badge ${plan.badgeClass}`}>
              {plan.badge}
            </div>
          </div>
        </div>

        {/* BACK */}
        <div className="card-back">
          <div className={`card-background ${plan.cardBackground}`} />
          <div
            className={`magnetic-stripe ${plan.chipGold ? 'gold' : ''}`}
          />
          <div className="signature-strip">
            <div className="cvv-box">
              <span className="cvv-label">CVV</span>
              <span className="cvv-value">•••</span>
            </div>
          </div>

          <div className="card-back-info">
            <p>Diese Karte ist Eigentum der ausstellenden Bank.</p>
            <p>Bei Fund bitte zurückgeben.</p>
          </div>

          <div className="card-back-logo">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
              alt="VISA"
            />
          </div>
        </div>
      </div>

      {/* PLAN DETAILS */}
      <div className="plan-details">
        <h3 className="plan-name">{plan.name}</h3>

        <div className="plan-info">
          <div className="info-row">
            <i className="fas fa-euro-sign" aria-hidden="true" />
            <span>
              Kreditbetrag: <strong>{plan.creditRange}</strong>
            </span>
          </div>

          <div className="info-row">
            <i className="fas fa-calendar-alt" aria-hidden="true" />
            <span>
              Laufzeit: <strong>{plan.duration}</strong>
            </span>
          </div>

          <div className="info-row fee">
            <i className="fas fa-tag" aria-hidden="true" />
            <span>
              Kartengebühr: <strong className="price">{plan.fee}</strong>
            </span>
          </div>
        </div>

        <button
          className="select-btn"
          onClick={handleSelect}
          aria-label={`${plan.name} für ${plan.fee} auswählen`}
        >
          <span>Plan Auswählen</span>
          <i className="fas fa-arrow-right" aria-hidden="true" />
        </button>
      </div>
    </article>
  )
}

export default CreditCard
